<template>
  <div class="popup-back">
    <div class="popup-page">
      <div class="popup-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>

.popup-back {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.popup-page {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  margin: 0 auto;
}

@media screen and (min-width: 640px) {
  .popup-page {
    max-width: 640px;
  }
}

@media screen and (min-width: 768px) {
  .popup-page {
    max-width: 768px;
  }
}

.popup-content {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
